module.exports = __webpack_public_path__ + "static/media/Avatars_Male-09.6355dfbe.png";